'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _styled = _interopDefault(require('@emotion/styled-base'));
var React = require('react');
var React__default = _interopDefault(React);
var noneOf = require('./none-of.js');

var OldConstraint =
/*#__PURE__*/
_styled('div', {
  shouldForwardProp: noneOf.noneOf(['as', 'width', 'height', 'centered']),
  target: "ew61ko50"
})(function (props) {
  return props.width && "max-width: ".concat(props.width, "px");
}, ";", function (props) {
  return props.height && "max-height: ".concat(props.height, "px");
}, ";", function (props) {
  return props.centered && "margin: auto";
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbnN0cmFpbnQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBUUUiLCJmaWxlIjoiY29uc3RyYWludC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcblxuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5cbmltcG9ydCB7IG5vbmVPZiB9IGZyb20gJy4vbm9uZS1vZidcblxuY29uc3QgT2xkQ29uc3RyYWludCA9IHN0eWxlZCgnZGl2Jywge1xuICBzaG91bGRGb3J3YXJkUHJvcDogbm9uZU9mKFsnYXMnLCAnd2lkdGgnLCAnaGVpZ2h0JywgJ2NlbnRlcmVkJ10pLFxufSlgXG4gICR7cHJvcHMgPT4gcHJvcHMud2lkdGggJiYgYG1heC13aWR0aDogJHtwcm9wcy53aWR0aH1weGB9O1xuICAke3Byb3BzID0+IHByb3BzLmhlaWdodCAmJiBgbWF4LWhlaWdodDogJHtwcm9wcy5oZWlnaHR9cHhgfTtcbiAgJHtwcm9wcyA9PiBwcm9wcy5jZW50ZXJlZCAmJiBgbWFyZ2luOiBhdXRvYH07XG5gXG5cbmV4cG9ydCBmdW5jdGlvbiBDb25zdHJhaW50KHByb3BzKSB7XG4gIGlmIChwcm9jZXNzLmVudi5OT0RFX0VOViAhPT0gJ3Byb2R1Y3Rpb24nKSB7XG4gICAgLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIG5vLWNvbnNvbGVcbiAgICBjb25zb2xlLndhcm4oXG4gICAgICAnREVQUkVDQVRFRCcsXG4gICAgICAnPENvbnN0cmFpbnQ+IGNvbXBvbmVudCBpcyBkZXByZWNhdGVkIGFuZCB3aWxsIGJlIHJlbW92ZWQuIFVzZSA8Qm94PiBjb21wb25lbnQgaW5zdGVhZCdcbiAgICApXG4gIH1cbiAgcmV0dXJuIDxPbGRDb25zdHJhaW50IHsuLi5wcm9wc30gLz5cbn1cbiJdfQ== */"));

function Constraint(props) {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.warn('DEPRECATED', '<Constraint> component is deprecated and will be removed. Use <Box> component instead');
  }

  return React__default.createElement(OldConstraint, props);
}

exports.Constraint = Constraint;
//# sourceMappingURL=constraint.js.map
